import { useEffect } from "react";

import ModalsService from "services/modals-service";

import { putStorage, useStorageListener } from "hooks/useStorage";

import { EModals } from "types/enums";

const useModal = (name: string | EModals, options?: any) => {
    const { onOpen = () => {}, onClose = () => {} } = options ?? {};

    const modal = useStorageListener(`modals.${name}`, {});
    const { isOpened = false, preventClosing = false, state = {} } = modal;

    useEffect(() => {
        if (isOpened) {
            onOpen?.(state);
        } else {
            onClose?.();
        }
    }, [isOpened]);

    const handlers = {
        open: () => ModalsService.showModal(name),
        close: () => !preventClosing && ModalsService.hideModal(name),
        setPreventClosing: (newValue: boolean) => putStorage(`modals.${name}.preventClosing`, newValue),
        setStateByKey: (key: string, value: any) => putStorage(`modals.${name}.state.${key}`, value),
        setState: (newState: any) => putStorage(`modals.${name}.state`, newState),
    };

    return { name, ...modal, ...handlers };
};

export default useModal;
